// extracted by mini-css-extract-plugin
export default {"cls1":"SearchBar-cls1___925c7b716601f2eed2d","cls2":"SearchBar-cls2___54c172fc1626fbf1d33 SearchBar-cls1___925c7b716601f2eed2d"};